import { ApiCall } from '../ApiClient';
import { BoardData, RangeResult, ResultData, UserLiteData } from '../ApiTypes';
import { dateTransformer } from '../ApiUtil';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

const put = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'put' });

export interface TaskLiteData {
    id: string;
    ref: string;
    summary: string;
    status: string;
    dueDate: string;
    createdAt: Date;
    updatedAt: Date;
}

export interface TaskData extends TaskLiteData {
    user: UserLiteData;
    board: BoardData;
}

export interface TaskCreateInput {
    localId: string;
    summary?: string;
    dueDate?: string;
    status?: string;
    userId?: string;
}

export interface TaskPatchInput {
    id: string;
    summary?: string;
    dueDate?: string;
    status?: string;
    userId?: string;
}

export interface TaskListQuery {
    workspaceId: string;
    search?: string;
    userFilter?: string[];
    statusFilter?: string;
    sort?: string;
    startAt?: number;
    maxResults?: number;
}

export interface TaskUserListQuery {
    workspaceId: string;
}

export const tasksEndpoints = {

    users: {

        list: (query: TaskUserListQuery) => get<UserLiteData[]>({
            path: '/tasks.users.list',
            query: {
                ...query,
            },
            transform: dateTransformer(),
        }),

    },

    list: ({ userFilter, ...rest }: TaskListQuery) => get<RangeResult<TaskData>>({
        path: '/tasks.list',
        query: {
            userFilter: userFilter?.join(','),
            ...rest,
        },
        transform: dateTransformer({ ignore: ['dueDate'] }),
    }),

    load: (body: { boardId: string, taskIds: string[] }) => post<ResultData>({
        path: '/tasks.load',
        body,
    }),

    create: (body: { boardId?: string, workspaceId?: string, items: TaskCreateInput[] }) => post<{ mappings: Record<string, string> }>({
        path: '/tasks.create',
        body,
    }),

    patch: (body: { items: TaskPatchInput[] }) => post<ResultData>({
        path: '/tasks.patch',
        body,
    }),

    delete: (body: { taskIds: string[] }) => post<ResultData>({
        path: '/tasks.delete',
        body,
    }),

    // Other task-related endpoints can be added here as needed
};
